import { Box, CardMedia, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import white_tshirt from "../../assets/images/drop_order.png";
import black_tshirt from "../../assets/images/Mockup_black.jpg";

const OrdersCard = ({ order, docData, currentUser }) => {
  return (
    <Grid item xs={12} md={6} align="center" mt="10px">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        boxShadow="2"
        marginTop="10px"
      >
        <Box
          sx={{
            height: "250px",
            border: "2px solid black",
            backgroundColor: "black",
          }}
        >
          <CardMedia
            component="img"
            image={
              order?.size?.indexOf("White") >= 0 ? white_tshirt : black_tshirt
            }
            alt="image"
            sx={{ height: "250px", width: "213px" }}
          />
        </Box>

        <Typography fontWeight="bold" fontSize="30px">
          paint | PHYSICAL T-SHIRT
        </Typography>
        <Typography fontSize="12px" marginBottom="10px">
          A young Ukrainian girl defiantly painting a new future because
          self-belief is the best middle finger to oppression.
        </Typography>
      </Box>
    </Grid>
  );
};

export { OrdersCard };
